module.exports = __webpack_public_path__ + "static/media/img_location_la.bf19fcd5.jpg";